import Swal from "sweetalert2";
import { unapplyNotaComercial } from "../utils/offerNotaComercialOnOperationCreate";
import { clearNotaComercialPendingCache } from "../utils/notaComercialPendingContacts";

/**
 * Sacar de una operación una nota comercial que se le aplicó por error.
 *
 * Lo usan las dos pantallas de finance, que listan las notas aplicadas con formas de
 * objeto distintas: por eso el nombre a mostrar se pasa hecho en vez de deducirlo acá.
 */
export default {
  methods: {
    /**
     * @param {{noteId: string, noteName?: string, targetType: 'proform'|'shipping', targetId: string|number, operationName?: string}} params
     * @returns {Promise<boolean>} true si se quitó
     */
    async unapplyNotaComercialFromOperation(params = {}) {
      const noteId = params.noteId != null ? String(params.noteId).trim() : "";
      const targetId = params.targetId != null ? String(params.targetId).trim() : "";
      if (!noteId || !targetId) return false;

      const confirmed = await Swal.fire({
        icon: "warning",
        title: this.$tn("notaComercial.unapply.confirmTitle"),
        text: this.$tn("notaComercial.unapply.confirmText", {
          note: params.noteName || noteId,
          operation: params.operationName || "",
        }),
        showCancelButton: true,
        confirmButtonText: this.$tn("notaComercial.unapply.confirmButton"),
        cancelButtonText: this.$tn("notaComercial.offerOnCreate.skip"),
        heightAuto: false,
      });
      if (!confirmed.isConfirmed) return false;

      const res = await unapplyNotaComercial(noteId, {
        targetType: params.targetType,
        targetId,
      });
      if (!res.ok) {
        await Swal.fire({
          icon: "error",
          title: this.$tn("notaComercial.unapply.errorTitle"),
          text: this.$tn("notaComercial.unapply.errorGeneric"),
          heightAuto: false,
        });
        return false;
      }

      // El saldo del contacto cambió: el aviso y el botón de asignar tienen que releer.
      clearNotaComercialPendingCache();
      return true;
    },
  },
};
